import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageUserAdsTable} from "../../UI/Main/ManageUserAdsTable";

const ManageUserAds = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageUserAdsTable />} />
        </div>
    );
};

export default ManageUserAds;
